module.exports = __webpack_public_path__ + "static/txtling3-432475e73c9d10049108b68c3a02cb88.png";